import { useEffect } from "react";
import FrappeFormEmbed from "./FrappeFormEmbed";
import { useRouter } from "next/router";

interface ILeadGenForms {
  type?: "frappe";
  url: string;
  wrapperClass?: string;
  mode?: "popup" | "inline";
  loader?: "shimmer" | "spinner";
  setHeight?: (height: number) => void;
  onClose?: () => void;
}

const LeadGenForms: React.FC<ILeadGenForms> = ({ type = "frappe", url, wrapperClass, mode = "popup", loader = "spinner", setHeight, onClose }) => {
  const router = useRouter();
  useEffect(() => {
    const onMessage = (event: MessageEvent) => {

      if (
        event.data?.eventName === "HEIGHT_UPDATE" &&
        typeof event.data.iframeHeight === "number"
      ) {
        setHeight?.(event.data.iframeHeight);
      }

      if (
        event.data.type === "FRAPPE_HEIGHT" &&
        typeof event.data.height === "number"
      ) {
        setHeight?.(event.data.height);
      }

      if (event.data?.eventName === "FORM_SAVED") {
        if(event?.data?.formData) {
          sessionStorage.setItem("formData", JSON.stringify(event?.data?.formData));
        }
        
        if (
          router.asPath.includes(
            "/student-services/education-loan-for-overseas-education"
          )
        ) {
          window.open(
            "https://www.elanloans.com/thankyou?msg=success",
            "_blank"
          );
        } else if (router.asPath.includes("/entrepreneur/franchise-proposal")) {
          window.open(
            "https://www.studiesabroadfranchisee.com/thankyou",
            "_blank"
          );
        } else {
          window.location.href = window.location.origin + "/thank-you";
        }
        onClose?.();
      }
    };
    window.addEventListener("message", onMessage);
    return () => window.removeEventListener("message", onMessage);
  }, []);
  
  if (type === "frappe") {
    return <FrappeFormEmbed iframeUrl={url} frappeWrapperClass={wrapperClass} mode={mode} loader={loader} />;
  }
  return <div>Form type not found.</div>;
};

export default LeadGenForms;